// Parser de NF-e XML — extraído de App.jsx — Fase C

function parseNFe(xmlText) {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(xmlText, "application/xml");
    const err = doc.querySelector("parsererror");
    if (err) return { error: "XML inválido. Verifique o arquivo." };

    const g = (tag) => doc.querySelector(tag)?.textContent?.trim() || "";
    const all = (tag) => [...doc.querySelectorAll(tag)];

    // Header info
    const numero   = g("nNF");
    const serie    = g("serie");
    const emissao  = g("dhEmi") || g("dEmi");
    const emissaoFmt = emissao ? emissao.substring(0,10) : "";
    const natOp    = g("natOp");
    const cnpjEmit = g("emit CNPJ");
    const nomeEmit = g("emit xNome") || g("emit xFant") || "";
    const totalNF  = parseFloat(g("vNF") || g("vTotTrib") || "0") || 0;

    if (!numero) return { error: "Arquivo não parece ser uma NF-e válida. Certifique-se de usar o XML da NF-e." };

    // Products
    const prods = all("det").map(det => {
      const name    = det.querySelector("xProd")?.textContent?.trim() || "Produto sem nome";
      const unit    = det.querySelector("uCom")?.textContent?.trim() || "Unid.";
      const qty     = parseFloat(det.querySelector("qCom")?.textContent || "0");
      const unitVal = parseFloat(det.querySelector("vUnCom")?.textContent || "0");
      const total   = parseFloat(det.querySelector("vProd")?.textContent || "0");
      const ncm     = det.querySelector("NCM")?.textContent?.trim() || "";
      const ean     = det.querySelector("cEAN")?.textContent?.trim() || "";
      return { name, unit, qty, unitVal, total, ncm, ean };
    });

    return { ok:true, numero, serie, emissao:emissaoFmt, natOp, cnpjEmit, nomeEmit, totalNF, prods };
  } catch(e) {
    return { error: "Erro ao processar XML: " + e.message };
  }
}

// Map NF-e unit to app unit
function mapUnit(u="") {
  const m = u.toUpperCase();
  if(["KG","KGS","KILO","QUILOGRAMA"].includes(m)) return "Kg";
  if(["L","LT","LTS","LITRO","LITROS"].includes(m)) return "Litros";
  if(["SC","SAC","SACO","SACAS"].includes(m)) return "Sacos";
  if(["CX","CAIXA","CAIXAS"].includes(m)) return "Caixas";
  if(["FD","FARDO","FARDOS"].includes(m)) return "Fardos";
  return "Unid.";
}

// Movement types for stock

export { parseNFe, mapUnit };
